@use '../common/colors.scss' as colors;
@use '../common/vars' as vars;

.verify-wrapper {
  display: flex;
  flex-direction: column;
  width: 66.6666%;
  max-width: 450px;
  margin: 0 auto;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

:global(#group-mobile-verification-code) {
  margin-bottom: 0;

  label {
    width: 100%;
    display: inline-block;
    text-align: center;
    font-size: 0.85em;
    color: colors.$body-text;
  }
}

:global(#error-mobile-verification-code) {
  color: colors.$danger;
}

.verify-header {
  margin-top: 2em;
  margin-bottom: 0.6em;
  text-align: center;
  line-height: 1.1;

  @media screen and (max-width: vars.$mobile) {
    margin-top: 2em;
    h1 {
      font-size: 1em;
    }
  }
}

.verify-header.error {
  margin-top: 0;
}

:global(.header-txt).verify-header {
  line-height: 33px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 1.5em;
  }
}

.sms-resend {
  margin-bottom: 1.5em;
  font-size: 0.8em;

  a:hover {
    text-decoration: underline;
  }

  @media screen and (max-width: vars.$mobile) {
    margin-bottom: 4.25em;
  }
}

.sms-resend-now-wrapper,
#sms-resend-code {
  width: 100%;
  text-align: right;
}

.sms-resend-now-wrapper {
  @media screen and (max-width: vars.$mobile) {
    text-align: left;
  }
}

.verify-form-submit {
  margin-bottom: 10px;
  font-size: 1.125em;
  padding: 10px 16px;
}

// Flexpay
:global(.flexpay) {
  .verify-form-submit {
    padding: 18px 0;
  }

  #sms-resend-code,
  :global(#sms-resend-now) {
    color: colors.$flexpay-green;
    text-decoration: none;
  }

  :global(#group-mobile-verification-code) {
    input {
      letter-spacing: 4px;
    }

    label {
      margin-bottom: 32px;
      color: colors.$flexpay-body-text;
    }
  }
}
